// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  defaultLanguage: 'hr',
  firebaseConfig: {
    apiKey: "AIzaSyANbvKWncT7SMnoYNOm0nmNF_m1QYkl2C8",
    authDomain: "scanshop-landing.firebaseapp.com",
    projectId: "scanshop-landing",
    storageBucket: "scanshop-landing.appspot.com",
    messagingSenderId: "46687956220",
    appId: "1:46687956220:web:32ebc9acfcdb9d16a8fb79",
    measurementId: "G-9YB2NG1G49"
  },
  // NOTE: implicit STATIC app are at port 1668 and hostname endsWith .netlify.app
  static: {
    hosts: [
      'www.ss.hr', // @Netlify
      'ss.hr',     // @Netlify
    ]
  },
  // NOTE: implicit DYNAMIC app is at ports 4200 and 1864 and hostname endsWith .web.app
  dynamic: {
    hosts: [
      // NOTE: explicit hostname endsWith .web.app is redundant but only defined as placeholder to be as example
      'scanshop-landing.web.app', // @Firebase Hosting
      'preview.landing.ss.hr',    // @Firebase Hosting
    ]
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
